import classNames from 'classnames';
import he from 'he';
import fp from 'lodash/fp';
import queryString from 'query-string';
import React from 'react';
import { Button, Col, MenuItem, NavDropdown, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, lifecycle, renderComponent, withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators } from 'redux';
import exportCpdReportPdf from '../../../../../../src/reports/export-cpd-report-pdf';
import { routes, tabKeys } from '../../../../../constants';
import { fullName, isBusinessAdmin, isMinimumBased } from '../../../../../services';
import { startOfNextCpdPeriod, startOfThisCpdPeriod } from '../../../../../services/cpd-settings';
import { businessActions } from '../../../../../state/modules/business';
import { businessSelector } from '../../../../../state/modules/business/selectors';
import { currentUserIdSelector, currentUserIndustry, currentUserSelector } from '../../../../../state/modules/user';
import { eventHandler, noCapMap, pluralise, unfixedFloor } from '../../../../../utils';
import { ConfirmationModal } from '../../../../components';
import { ProgressChart } from '../../../../partials';
import Loading from '../../../loading';
import { aoaProgressMap } from '../../dashboard/area-of-advice';

const nonChildCpdCategoryFilter = (cpdCategorys, industryCpdCategorys, isMinimumBased) => isMinimumBased ? fp.filter(
  ({
    cpdCategoryId
  }) => {
    const nonChildCpdCategory = fp.filter(
      ({ parentCpdCategoryId }) => !parentCpdCategoryId
    )(industryCpdCategorys)
    return fp.find(
      ({ id }) => id === cpdCategoryId
    )(nonChildCpdCategory)
  }
)(fp.filter((aoa) => !aoa.isExternal)(cpdCategorys)) : cpdCategorys

const TeamMemberRow = ({
  teamMember: {
    user: {
      id
    },
    isTeamManager
  },
  teamMember,
  cpdCategorysStats,
  cpdCategorys,
  toggleOpen,
  setIsOpen,
  isOpen,
  currentUser,
  cappedProgressPercentage,
  userName,
  userCpdDaysRemaining,
  afsLicence,
  downloadReport,
  businessTeam,
  makeManager,
  removeManager,
  removeMember,
  currentUserId,
  showingRemoveMemberModal,
  showRemoveMemberModal,
  hideRemoveMemberModal,
  displayProgress,
  isMinimumBased,
  industryCpdCategorys,
  hidePointsFraction,
  hideDaysRemaining
}) => (
    <div className={classNames('teamListing', { opened: isOpen })} onClick={toggleOpen}>
      <span className='icon-chevron-down-large closeListing cell-top-padded' />
      <Row className='sm-gutter team-infoRow'>
        {
          displayProgress ? (<Col xs={3} md={1}>
            <div className='chart'>
              <ProgressChart progressPercentage={cappedProgressPercentage} width={200} height={200} />
            </div>
          </Col>) : null
        }
        <Col xs={displayProgress ? 3 : 6} md={displayProgress ? 3 : 4}>
          <h2>
            {userName}
          </h2>
          <p>
            <strong>
              <small>
                {isBusinessAdmin(teamMember) ? 'Team administrator' :
                  isTeamManager ? 'Team supervisor' : null}
              </small>
            </strong>
          </p>
          {
            hidePointsFraction ? null : <p>
              <small>
                {`${unfixedFloor(cpdCategorysStats.primaryStat.validCpd, 2)}/${cpdCategorysStats.primaryStat.goal}`} points
            </small>
            </p>
          }
          {
            hideDaysRemaining ? null : <p>
              <small>
                {userCpdDaysRemaining} {pluralise('day', userCpdDaysRemaining)} remaining
            </small>
            </p>
          }
        </Col>
        <Col xsOffset={3} xs={2} mdOffset={6} md={2} className='text-center'>
          <NavDropdown
            id='team-member-menu'
            title='Actions'
            className='pull-left align-right cell-top-padded'
            noCaret={true}
            onClick={eventHandler()}>
            <MenuItem>
              <LinkContainer
                to={businessTeam ? routes.app.teams.teamMemberReport(businessTeam.businessTeam.id, id) : routes.app.teams.allTeamMemberReport(id)}
                bsStyle='plain'
                className='menu-item'>
                <Button>
                  Progress report
                </Button>
              </LinkContainer>
            </MenuItem>
            {
              currentUserId !== id ?
                <LinkContainer
                  to={isBusinessAdmin ? routes.app.trainingPlansSettings(tabKeys.trainingPlansSettings.allTrainingPlans + `?${queryString.stringify({ user: userName })}`) : routes.app.trainingPlansSettings(tabKeys.trainingPlansSettings.teamTrainingPlans)}>
                  <MenuItem>
                    Edit training plan
                  </MenuItem>
                </LinkContainer> :
                null
            }
            {
              currentUserId !== id ?
                <LinkContainer
                  to={businessTeam ? routes.app.teams.teamMemberProfiles(businessTeam.businessTeam.id, id) : routes.app.teams.userProfiles(id)}>
                  <MenuItem>
                    View profile
                  </MenuItem>
                </LinkContainer> :
                null
            }
            {
              businessTeam && currentUserId !== id ?
                <MenuItem>
                  <Button
                    bsStyle='plain'
                    className='remove'
                    onClick={eventHandler(showRemoveMemberModal)}>
                    Remove from team
                  </Button>
                </MenuItem> :
                null
            }
          </NavDropdown>
        </Col>
      </Row>
      <Row className='sm-gutter advicesRow'>
        {
          fp.flow(
            fp.values,
            fp.map(({
              cpdCategoryId,
              primaryStat: {
                validCpd,
                goal
              },
              derivedStat: {
                shortFall,
                progress
              }
            }) => ({
              cpdCategoryId,
              validCpd,
              goal,
              shortFall,
              progress,
              title: fp.find(({ id }) => id === cpdCategoryId)(cpdCategorys).name,
              icon: fp.find(({ id }) => id === cpdCategoryId)(cpdCategorys).iconUrl
            })),
            fp.orderBy(['shortFall', 'title'], ['desc', 'asc']),
            noCapMap(({
              cpdCategoryId,
              validCpd,
              goal,
              shortFall,
              title,
              progress,
              icon
            }, index) =>
              <Col key={`${id}-${index}`} xs={12} ms={4} sm={4} md={3} lg={2}>
                <div className='highlight--areas-of-advice'>
                  <h3>
                    {title}
                  </h3>
                  {
                    isMinimumBased ?
                      icon ? <img className="category-icon" src={he.decode(icon)} alt={title} /> : null :
                      <ProgressChart progressPercentage={progress} width={200} height={200} />
                  }
                  <div className='info'>
                    <span>
                      {
                        isMinimumBased ? aoaProgressMap(title, `${validCpd}/${goal}`) : <span>{validCpd}/{goal} CPD Hours</span>
                      }
                    </span>
                  </div>
                </div>
              </Col>
            )
          )(nonChildCpdCategoryFilter(cpdCategorysStats.cpdCategorys, industryCpdCategorys, isMinimumBased))
        }
      </Row>
      <ConfirmationModal
        show={showingRemoveMemberModal}
        actions={[{
          onConfirmAction: removeMember,
          actionLabel: 'Yes, remove this team member',
          actionClass: 'btn-delete'
        }]}
        cancel={hideRemoveMemberModal}
        headingText={<span>Remove member</span>}
        message={<p>Removing this team member will only delete the member from this team, and will not delete any progress associated with this user. To confirm you wish to remove this team member click yes below.</p>}
        cancelLabel={`Cancel`} />
    </div>
  );



const mapStateToProps = ({ cpdCategorys, publisher, business, industry, ...state }, { teamMember }) => ({
  cpdActivity: business.cpdActivities ? business.cpdActivities.userCpdPoints : [],
  cpdCategorys: cpdCategorys.cpdCategorys,
  industryCpdCategorys: industry.cpdCategorys,
  cpdCategoryProgress: business.memberCpdCategorys,
  currentUser: currentUserSelector(state),
  currentUserId: currentUserIdSelector(state),
  isMinimumBased: isMinimumBased(currentUserIndustry(state)),
  publishers: publisher.publishers,
  afsLicence: business.afsLicences && business.afsLicences[0],
  isFetchingCpdActivities: business.isFetchingCpdActivities,
  isFetchingMemberCpdCategorys: business.isFetchingMemberCpdCategorys,
  fetchedCpdActivitiesUserID: business.fetchCpdActivitiesUserID,
  business: businessSelector({ business }),
  userIndustryType: fp.flow(currentUserIndustry, fp.first, fp.get('industryType'))(state),
  totalCpdProgress: fp.find(
    ({ userId }) => userId === teamMember.user.id
  )(business.teamCpdCategorys ? business.teamCpdCategorys : business.team.cpdCategorys)
});

const mapDispatchToProps = (dispatch) => ({
  fetchCpdActivities: bindActionCreators(businessActions.business.user.getCpdActivities, dispatch),
  fetchUserCpdCategorys: bindActionCreators(businessActions.business.user.getCpdCategorys, dispatch),
  addTeamManager: bindActionCreators(businessActions.business.team.addTeamManager, dispatch),
  removeTeamManager: bindActionCreators(businessActions.business.team.removeTeamManager, dispatch),
  removeTeamMember: bindActionCreators(businessActions.business.team.removeTeamMember, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStateHandlers(
    {
      isOpen: false,
      fetchCpdActivitiesUserID: null
    },
    {
      setIsOpen: ({ isOpen }) => (value) => ({
        isOpen: value,
      }),
      updateFetchCpdActivityUserID: ({ fetchCpdActivitiesUserID }) => (value) => ({
        fetchCpdActivitiesUserID: value
      })
    }
  ),
  withProps(({
    userCpdDaysRemaining,
    cpdCategorysStats,
    teamMember: {
      user: {
        firstName,
        lastName
      }
    }
  }) => ({
    cappedProgressPercentage: cpdCategorysStats ? cpdCategorysStats.derivedStat.progress : 0,
    userName: fullName({ firstName, lastName }),
    filter: {
      skip: 0,
      sort: '',
      fromDate: startOfThisCpdPeriod(userCpdDaysRemaining),
      toDate: startOfNextCpdPeriod(userCpdDaysRemaining)
    },
  })),
  withStateHandlers(() => ({
    showingRemoveMemberModal: false
  }), {
      showRemoveMemberModal: () => () => ({ showingRemoveMemberModal: true }),
      hideRemoveMemberModal: () => () => ({ showingRemoveMemberModal: false })
    }
  ),
  withHandlers({
    makeManager: ({ teamMember, business, businessTeam, addTeamManager }) => () => {
      addTeamManager(business.id, businessTeam.businessTeam.id, teamMember.user)
    },
    removeManager: ({ teamMember, business, businessTeam, removeTeamManager }) => () => {
      removeTeamManager(business.id, businessTeam.businessTeam.id, teamMember.user)
    },
    removeMember: ({ teamMember, business, businessTeam, removeTeamMember, hideRemoveMemberModal }) => (e) => {
      hideRemoveMemberModal()
      removeTeamMember(business.id, businessTeam.businessTeam.id, teamMember.user)
    },
  }),
  withHandlers({
    toggleOpen: ({ isOpen, setIsOpen }) => (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(!isOpen);
    },
    downloadReport: ({
      business: {
        id: businessId
      },
      teamMember: {
        user: {
          id: teamMemberId
        }
      },
      filter,
      fetchCpdActivitiesUserID,
      fetchCpdActivities,
      fetchUserCpdCategorys,
      updateFetchCpdActivityUserID }) => (e) => {
        e.stopPropagation()
        e.preventDefault()
        updateFetchCpdActivityUserID(teamMemberId)
        fetchCpdActivities(businessId, teamMemberId, filter)
        fetchUserCpdCategorys(businessId, teamMemberId)
      }
  }),
  lifecycle({
    componentWillReceiveProps({
      isFetchingCpdActivities,
      fetchCpdActivitiesUserID,
      isFetchingMemberCpdCategorys,
      teamMember,
      publishers,
      cpdCategoryProgress,
      cpdActivity,
      updateFetchCpdActivityUserID,
      afsLicence,
      cpdCategorys,
      userCpdDaysRemaining: cpdDaysRemaining,
      filter,
      teamMember: {
        user
      },
      userIndustryType,
      totalCpdProgress,
      industryCpdCategorys
    }) {
      if (
        teamMember.user.id === fetchCpdActivitiesUserID &&
        publishers && publishers.length > 0 &&
        cpdCategoryProgress &&
        cpdActivity
      ) {
        // check that user matches
        if ((fetchCpdActivitiesUserID === cpdCategoryProgress.userId) &&
          (cpdActivity.length === 0 || fetchCpdActivitiesUserID === cpdActivity[0].userId) &&
          ((!isFetchingCpdActivities && this.props.isFetchingCpdActivities && !isFetchingMemberCpdCategorys) ||
            (!isFetchingMemberCpdCategorys && this.props.isFetchingMemberCpdCategorys && !isFetchingCpdActivities))) {
          exportCpdReportPdf({
            afsLicence,
            cpdCategorys,
            cpdActivity,
            cpdDaysRemaining,
            industryCpdCategorys,
            filter,
            publishers,
            user,
            userIndustryType,
            cpdCategoryProgress
          })
          updateFetchCpdActivityUserID(null)
        }
      }
    }
  }),
  branch(
    ({ cpdCategorysStats }) => !cpdCategorysStats,
    renderComponent(Loading)
  )
)(TeamMemberRow);



// WEBPACK FOOTER //
// ./src/containers/pages/app/teams/partials/team-member-row.js